import { createApi } from '@reduxjs/toolkit/query/react';

import { emptyBillingDetails } from '@app/api/team';
import type { BillingDetails, BillingDetailsResponse } from '@app/api/types';

import fetchBaseQuery from '../fetchBaseQuery';

export interface CreditCard {
    id: number;
    brand: string;
    last4: string;
    isDefault: boolean;
}

const userApi = createApi({
    reducerPath: 'lokaliseInternal_user',
    baseQuery: fetchBaseQuery(),
    tagTypes: [],
    endpoints: (builder) => ({
        getUserBillingDetails: builder.query<BillingDetails, void>({
            query: () => ({
                method: 'GET',
                url: '/user/billing-details',
            }),
            // Empty array is returned from our BE when there is no data.
            // see https://lokalise.atlassian.net/browse/GROW-665 for details.
            transformResponse: (response: BillingDetailsResponse) => {
                if (Array.isArray(response)) {
                    return emptyBillingDetails;
                }

                return response;
            },
        }),
        getUserCards: builder.query<CreditCard[], void>({
            query: () => ({
                method: 'GET',
                url: '/user/cards',
            }),
        }),
        updateUserBillingDetails: builder.mutation<BillingDetails, BillingDetails>({
            query: (data) => ({
                method: 'PUT',
                url: '/user/billing-details',
                body: data,
            }),
        }),
    }),
});

export default userApi;

export const { useGetUserBillingDetailsQuery, useGetUserCardsQuery, useUpdateUserBillingDetailsMutation } = userApi;
